import React, { FunctionComponent } from 'react';
import './publishing-sdk-card.scss';
import { environment } from '../../../enviroment';
import { ContextPluginShowcaseCard } from './components/ContextPluginShowcaseCard';
import { FreeSetupCard } from './components/FreeSetupCard';
import { SetupGuideCard } from './components/SetupGuideCard';

export const PublishSDKCard: FunctionComponent<{ classes?: string }> = ({ classes = '' }) => {
    const localState = localStorage.getItem('portalEditorSettings');
    const settings = localState && JSON.parse(localState);
    const { apiGroupId, defaultApiEntityId, userEmail } = settings;
    const packagePublishingUrl = `${environment}/publish/${apiGroupId}/publish-now?api_version=${defaultApiEntityId}`;

    return (
        <div className={`flex flex-col ${classes}`}>
            <ContextPluginShowcaseCard />
            <FreeSetupCard apiEntityId={defaultApiEntityId} userEmail={userEmail} />
            <SetupGuideCard packagePublishingUrl={packagePublishingUrl} />
        </div>
    );
};
